import React from 'react'
import PropTypes from 'prop-types'
import {useIncrementingId} from '#hooks/useIncrementingId'

function Radio({labelText, value, checked, onChangeHandle, size, children, disabledState}) {
  const id = useIncrementingId()
  let modifier = checked ? 'radio--checked' : ''
  if (size) {
    modifier += ` radio--${size}`
  }
  if (disabledState) {
    modifier += ' radio--disabled'
  }
  const hasEvent = onChangeHandle && !disabledState

  return (
    <div className={`radio ${modifier}`}>
      <label htmlFor={id}>
        <div className="radio__indicator" />
        <input
          id={id}
          disabled={disabledState}
          type="radio"
          value={value}
          checked={checked}
          onChange={hasEvent ? elem => onChangeHandle(elem) : undefined}
        />
        <div>
          {labelText}
          {children}
        </div>
      </label>
    </div>
  )
}

Radio.propTypes = {
  labelText: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChangeHandle: PropTypes.func,
  size: PropTypes.string,
  children: PropTypes.node,
  disabledState: PropTypes.bool,
}

export default Radio
